import React from 'react';
import { WrappedFieldProps } from 'redux-form';
import { Text } from './styled';

const TextDisplay: React.FC<WrappedFieldProps> = ({ input: { value }, ...props }) => <Text {...props}>{value}</Text>;

export default TextDisplay;
